import { Component, Input } from '@angular/core';
import { RepresentanteFilter } from '../filter';
@Component({
    selector: 'sgt-representante-dashboard',
    templateUrl: './representante-dashboard.component.html',
    styleUrls: ['./representante-dashboard.component.less']
})
export class RepresentanteDashboardComponent {
    @Input() filter: RepresentanteFilter;

    load() {
        //
    }
}
